import { getApiBaseUrl } from "../../utils/apiBaseUrl";

type ShareResponse = {
  url: string;
  referralLink?: string;
};

export const ShareLink = async (
    addressId: number,
    token: string
  ): Promise<ShareResponse> => {
    const baseUrl = getApiBaseUrl();
    const apiUrl = `${baseUrl}/api/Share`;
    const payload = {addressId};
  
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
  
      if (!response.ok) {
        throw new Error(`Failed to share: ${response.statusText}`);
      }
  
      return response.json();
    } catch (error) {
      // console.error('Error in share', error);
      throw error;
    }
  };
  